import { useEffect } from 'react';
import { connectSocket, getSocket } from '../socket';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function useSocketNotifications(token) {
  useEffect(() => {
    if (token) connectSocket(token);
  }, [token]);
  useEffect(() => {
    const socket = getSocket();
    if (!socket) return;

    const handler = (data) => {
      toast.info(`${data.title}: ${data.message || 'New Notification!'}`, {
        position: 'top-right',
        autoClose: 4000,
      });
    };

    socket.on('notification:new', handler);

    return () => {
      socket.off('notification:new', handler); //cleanup
    };
  }, []);
}
